import { render, staticRenderFns } from "./Administracao.vue?vue&type=template&id=2afed00a&"
import script from "./Administracao.vue?vue&type=script&lang=js&"
export * from "./Administracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports